// 修改IP白名单
export const updateWhiteIp = async (params, type) => {
  const whiteIpUrl = {
    innerapp: 'apps',
    isv: 'isv/apps'
  };
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${whiteIpUrl[type]}/save/whiteips`,
    {
      method: "POST",
      body: JSON.stringify(params),
    }
  );
  return result;

};

// 查询IP白名单
export const getWhiteIp = async (params, type) => {
  const whiteIpUrl = {
    innerapp: 'apps',
    isv: 'isv/apps'
  };
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${whiteIpUrl[type]}/manage/config/${params.appId}`,
    {
      method: "get",
    }
  );
  return result;
};
